/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Contact\CompanyForm\CompanyForm.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Monday July 17th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday, 15th September 2023 06:16:44
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { forwardRef, useImperativeHandle, useState } from "react";
import Styles from "Content/Contact/CompanyForm/CompanyForm.module.css";
import { Form } from "react-bootstrap";
import { useLang } from "Router/LangueProvider";
import "react-phone-number-input/style.css";
import "Content/Contact/UserForm/PhoneInput.css";
import { TextField } from "@mui/material";
import { formatSiren } from "Utils/common.utils";

type CompanyFormProps = {
    onUpdate: Function
};

const CompanyForm = forwardRef((props: CompanyFormProps, ref) => {
    const {translator} = useLang();
    const [name, setName] = useState("");
    const [siren, setSiren] = useState("");

    useImperativeHandle(ref, () => {
        props.onUpdate();
        return {
            Name: name,
            Siren: siren
        };
    }, [name, siren]);

    const muiStyle = {
        width:"100%",
        "& .MuiFormLabel-asterisk": {
            color: "red"
        }
    };

    return (
        <div className={`${Styles.companyHolder}`}>
            <h3 className="m-0">{translator.decode("dynamic.company")}</h3>
            <Form.Group className={`${Styles.bgColor}`} >
                <TextField label={translator.decode("dynamic.companyName")} sx={muiStyle} size="small" required value={name ?? ""} onChange={(e) => {setName(e.target.value)}}/>
            </Form.Group>
            <Form.Group className={`${Styles.bgColor}`} >
                <TextField inputProps={{maxLength: 11}} label={translator.decode("dynamic.siren")} sx={muiStyle} size="small" required value={formatSiren(siren) ?? ""} onChange={(e) => {setSiren(e.target.value)}}/>
            </Form.Group>
        </div>
    )
});

export default CompanyForm;
